module.exports = __webpack_public_path__ + "img/sprite-social.7a56e6c4.png";